import { useContext, useEffect } from 'react';
import { DynamicPreloaders } from 'core/common/components/DynamicPreloaders';
import { screenComponents } from 'core/common/components/FlowScreens/screenComponents';
import { FlowVideoBackground } from 'core/common/components/FlowVideoBackground';
import { SupportBotButton } from 'core/common/components/SupportBotButton';
import { useLogger, useServices } from 'core/common/hooks';
import { QuizContext } from 'core/funnel/contexts';

type FlowScreensProps = {
  pageId: string;
};

const FlowScreens = ({ pageId }: FlowScreensProps) => {
  const logger = useLogger();
  const { gtmService, snapchatService } = useServices();
  const { flowInitialScreenId, getScreenAttributes } = useContext(QuizContext);

  const screenAttributes = getScreenAttributes(pageId);

  if (!screenAttributes) return null;

  const nextScreenAttributes = screenAttributes.next
    ? getScreenAttributes(screenAttributes.next)
    : null;

  const getScreen = () => {
    const { screenType } = screenAttributes;

    if (!screenComponents[screenType]) {
      logger.error(new TypeError(`Unknown step data: ${JSON.stringify(screenType)}`));
      return null;
    }
    const { Screen } = screenComponents[screenType];

    return <Screen id={pageId} />;
  };

  useEffect(() => {
    gtmService.pageView();
    snapchatService.pageView();
  }, [gtmService, snapchatService, pageId]);

  return (
    <>
      <FlowVideoBackground screenAttributes={screenAttributes} />
      {getScreen()}
      <DynamicPreloaders
        screenId={pageId}
        initialScreenId={flowInitialScreenId}
        screenAttributes={screenAttributes}
        nextScreenAttributes={nextScreenAttributes}
      />
      {screenAttributes.supportWidget && (
        <SupportBotButton variant="fixed" buttonText={screenAttributes.supportWidget.text} />
      )}
    </>
  );
};

export default FlowScreens;
